import { useTranslation } from "react-i18next";

import { Arrange, Typography } from "@aviary";
import eqpIcon from "@emerson/assets/svg/eqp_icon.svg";
import helpAndSupportIcon from "@emerson/assets/svg/help_and_support_icon.svg";
import shippingIcon from "@emerson/assets/svg/shipping_icon.svg";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./InfoPillars.styles";
const InfoPillars = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  return (
    <div css={[styles.mainWrapper, !tablet.greaterThan && styles.mobileWrapper]}>
      <div css={[styles.subWrapper, styles.shippingPadding]}>
        <img src={shippingIcon} alt="shipping icon" />
        <Arrange spacing="none" isVertical>
          <Typography type="body">{t(l.infoPillars.Shipping.line1)}</Typography>
          <Typography type="body">{t(l.infoPillars.Shipping.line2)}</Typography>
        </Arrange>
      </div>
      <div css={[styles.subWrapper, styles.extraPadding]}>
        <img src={helpAndSupportIcon} alt="help and support icon" />
        <Arrange spacing="none" isFullWidth isVertical>
          <Typography type="body">{t(l.infoPillars.HelpAndSupport.line1)}</Typography>
          <Typography type="body">{t(l.infoPillars.HelpAndSupport.line2)}</Typography>
        </Arrange>
      </div>
      <div css={[styles.subWrapper, styles.extraPadding]}>
        <img src={eqpIcon} alt="eqp icon" />
        <Arrange spacing="none" isFullWidth isVertical>
          <Typography type="body">{t(l.infoPillars.QualityProgram.line1)}</Typography>
          <Typography type="body">{t(l.infoPillars.QualityProgram.line2)}</Typography>
        </Arrange>
      </div>
    </div>
  );
};

export { InfoPillars };
